module.exports = __webpack_public_path__ + "img/ui_bedienung_0050.7299b83b.png";